import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useConfigContext } from "~/providers/ConfigContextProvider";

const VerticalSlider = dynamic(() => import("~/components/ui/VerticalSlider"));
const VerticalSliderItemProduct = dynamic(
  () => import("~/components/content/VerticalSliderItemProduct")
);

export const RelatedProducts = ({
  id,
  ids,
}: {
  id: number;
  ids: string[] | number[];
}) => {
  const [items, setItems] = useState<any>(null);
  const config = useConfigContext();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const controller =
      typeof AbortController !== "undefined"
        ? new AbortController()
        : undefined;

    const get = async () => {
      try {
        const response: any = await fetch(
          `${
            config.cmsUrl
          }/wp-content/plugins/ikon-custom/rest-api-products.php?count=5&id=${id}${
            ids?.length ? `&selectedIds=${ids.join(",")}` : ""
          }`,
          {
            signal: controller?.signal,
          }
        );
        const data = await response.json();

        if (data?.data?.length > 0) {
          setItems(data?.data);
        }
      } catch (err: any) {}
    };

    get();

    return () => {
      if (controller) {
        controller.abort();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let sortedItems: any[] = [];
  if (items?.length) {
    if (ids && ids?.length) {
      const sortedInListItems = (ids as any[]).reduce((carry: any[], id: any) => {
        const inList = items.slice(0, 5).find((item: any) => {
          return item.id === (typeof id === "string" ? parseInt(id) : id);
        });
        if (inList) {
          carry.push(inList);
        }
        return carry;
      }, []);

      sortedItems = [
        ...sortedInListItems,
        ...items.slice(0, 5).reduce((carry: any, item: any) => {
          if (!(ids as any[]).find((id: any) => {
            return item.id === (typeof id === "string" ? parseInt(id) : id)
          })) {
            carry.push(item);
          }
          
          return carry;
        },[]),
      ];
    } else {
      sortedItems = items.slice(0, 5);
    }
  }

  return (
    <>
      {sortedItems?.length > 0 && (
        <VerticalSlider
          key={`related`}
          header="Shop"
          hasNav
          spaceHeight={{
            base: [1, 2, 8],
            mobile: [1, 2, 8],
            tablet: [2, 3, 8],
            desktop: [2, 3, 8],
            screen: [2, 3, 8],
          }}
        >
          {sortedItems?.map((item: any, index: number) => {
            return (
              <VerticalSliderItemProduct
                item={item}
                key={`related-${index + 1}`}
              />
            );
          })}
        </VerticalSlider>
      )}
    </>
  );
};
